<div [ngClass]="type" class="image-container">
  <img [class.width-shorter]="!isLandscape" [src]="rawImagePath" draggable="false" id="parent"/>
  <div class="overlay"></div>
  <div class="selection-box">
    <div class="line vertical"></div>
    <div class="line horizontal"></div>
    <div class="resize-handle left"></div>
    <div class="resize-handle top-left"></div>
    <div class="resize-handle top"></div>
    <div class="resize-handle top-right"></div>
    <div class="resize-handle bottom-left"></div>
    <div class="resize-handle bottom"></div>
    <div class="resize-handle right"></div>
    <div class="resize-handle bottom-right"></div>
  </div>
</div>

